"use client";

import {ChangeEvent, JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/reviews-search.scss";

interface ReviewsSearchProps {
    onSearch?: (query: string) => void;
    onSort?: (sortBy: string) => void;
    className?: string;
}

export function ReviewsSearch({onSearch, onSort, className = ""}: ReviewsSearchProps): JSX.Element {
    const {t} = useTranslation("reviews");
    const {t: tCommon} = useTranslation("common");

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>): void => {
        if (onSearch) {
            onSearch(e.target.value);
        }
    };

    const handleSortChange = (e: ChangeEvent<HTMLSelectElement>): void => {
        if (onSort) {
            onSort(e.target.value);
        }
    };

    return (
        <div className={`reviews-search ${className}`}>
            <div className="reviews-search__input-wrapper">
                <SmartImage
                    src={assetPath("/images/icons/search.svg")}
                    alt={tCommon("search")}
                    width={20}
                    height={20}
                    className="reviews-search__icon"
                />
                <input type="text" placeholder={t("searchPlaceholder")} className="reviews-search__input" onChange={handleSearchChange} />
            </div>

            <div className="reviews-search__sort">
                <label htmlFor="sort-reviews" className="reviews-search__sort-label">
                    {t("sortBy")}
                </label>
                <select id="sort-reviews" className="reviews-search__select" onChange={handleSortChange} defaultValue="recent">
                    <option value="recent">{t("mostRecent")}</option>
                    <option value="highest">{t("highestRating")}</option>
                    <option value="lowest">{t("lowestRating")}</option>
                    <option value="oldest">{t("oldest")}</option>
                </select>
            </div>
        </div>
    );
}
